// TODO: find a better way to make this work
// uncomment below to mock correct fonts/icons
// import './honda.fonts.css';
import { isWindowMobile } from '../utils/media';
const fonts = {
    fontFamilyBase: "'HelveticaNeueLT-Roman',-apple-system,BlinkMacSystemFont,'Segoe UI','Roboto','Oxygen','Ubuntu','Cantarell','Fira Sans','Droid Sans','Helvetica Neue','Arial',sans-serif;",
    fontFamilyBold: "'HelveticaNeueLT-Bold','HelveticaNeueLT-Roman',-apple-system,BlinkMacSystemFont,'Segoe UI','Roboto','Oxygen','Ubuntu','Cantarell','Fira Sans','Droid Sans','Helvetica Neue','Arial',sans-serif;",
    fontFamilyHeading: "'national',-apple-system,BlinkMacSystemFont,'Segoe UI','Roboto','Oxygen','Ubuntu','Cantarell','Fira Sans','Droid Sans','Helvetica Neue','Arial',sans-serif;",
    icons: 'Material Icons',
};
const colors = {
    primaryBlack: '#1B1B1B',
    primaryRed: '#DC2440',
    primaryWhite: '#FFFFFF',
    secondaryBlue: '#007DBA',
    secondaryGreyDark: '#1B1B1B',
    secondaryRedLight: '#FDF4F5',
    secondaryRedDark: '#B31D34',
    tertiaryGreenDark: '#007B7D',
    tertiaryGreyDark: '#7A7A7A',
    tertiaryBlueDark: '#242C3B',
    tertiaryHoverBlue: '#054665',
    greyLight: '#F1F1F1',
    greyLightMedium: '#DDDDDD',
    greyDarkMedium: '#ABABAB',
    greyDark: '#595959',
    animatedRed: '#DB1735',
    trueBlack: '#000000',
};
const button = {
    buttonPrimaryTextColor: colors.primaryWhite,
    buttonPrimaryColor: colors.primaryRed,
    buttonPrimaryColorHover: colors.secondaryRedDark,
    buttonPrimaryDisabledColor: colors.greyDarkMedium,
    buttonSecondaryTextColor: colors.primaryBlack,
    buttonSecondaryColor: colors.primaryWhite,
    buttonSecondaryColorHover: colors.secondaryRedLight,
    buttonSecondaryBorder: `2px solid ${colors.primaryRed}`,
    buttonSecondaryDisabledColor: colors.greyLight,
    buttonSecondaryDisabledBorder: `2px solid ${colors.greyDarkMedium}`,
    buttonOutline: `1px solid ${colors.secondaryBlue}`,
};
const paragraph = {
    paragraphFontStyle: 'normal',
    paragraphFontWeight: 'normal',
    paragraphFontSize: '18px',
    paragraphFontSizeMobile: '16px',
    paragraphLineHeight: '28px',
    paragraphLineHeightMobile: '26px',
};
const hero = {
    heroTitleColour: 'white',
    heroBodyColour: 'white',
    heroBGRightGradient: `linear-gradient(270deg, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0.64) 40%, rgba(0, 0, 0, 0) 100%)`,
    heroBGLeftGradient: `linear-gradient(90deg, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0.64) 40%, rgba(0, 0, 0, 0) 100%)`,
    heroBGOverlay: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7))`,
};
export default Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, colors), fonts), button), hero), paragraph), { isWindowMobile: isWindowMobile(), name: 'Base' });
